/**
 * Debounces the form submission by disabling the submit button and
 * preventing multiple submissions.
 */
function submitDebounce() {
  const containers = [...document.querySelectorAll('.wpcf7')];
  const submitSelector = 'button[type="submit"]';

  function handleDisabledClick(e) {
    e.preventDefault();
  }

  function setLoading(container) {
    const submit = container.querySelector(submitSelector);
    submit.classList.add('disabled');
    submit.setAttribute('aria-disabled', 'true');
  }

  function unsetLoading(container) {
    const submit = container.querySelector(submitSelector);
    submit.classList.remove('disabled');
    submit.removeAttribute('aria-disabled', 'true');
  }

  function announce(form, message) {
    const liveRegion = form.querySelector('[aria-live]');

    if (liveRegion) {
      liveRegion.innerHTML = message;
    }
  }

  function setupEvents() {
    if (containers.length > 0) {
      containers.forEach((container) => {
        const form = container.querySelector('form');
        const submit = container.querySelector(submitSelector);

        [
          'wpcf7invalid',
          'wpcf7spam',
          'wpcf7mailsent',
          'wpcf7mailfailed',
          'wpcf7submit',
        ].forEach((evtName) => {
          container.addEventListener(
            evtName,
            (event) => {
              unsetLoading(event.target);
              submit.removeEventListener('click', handleDisabledClick);
              announce(form, '');
            },
            false,
          );
        });

        form.addEventListener(
          'submit',
          (event) => {
            setLoading(event.target);
            announce(event.target, 'Submitting data, please stand by');
            submit.addEventListener('click', handleDisabledClick);
          },
          false,
        );
      });
    }
  }

  setupEvents();
}

export function init() {
  submitDebounce();
}
